import HttpClient from "../helpers/HttpClient"
import { HttpError, isError } from "../helpers/Error"
import Preference, { PreferenceDto } from "./Preference"
import SignatureSettings from "./SignatureSettings"
import NotificationSettings from "./NotificationSettings"

class PreferenceService {
    static httpClient: HttpClient<Preference, PreferenceDto> = new HttpClient<Preference, PreferenceDto>(Preference)

    static async get(userId: string): Promise<Preference | HttpError> {
        const res = await this.httpClient.get(`/users/${userId}/preferences`)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Preference)
    }


    static async UpdateUserPreference(
        payload: object,
        userId: string
    ): Promise<Preference | HttpError> {
        const res = await this.httpClient.patch(`/users/${userId}/preferences`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Preference)
    }

    static async UpdateNotificationPreference(
        payload: NotificationSettings,
        userId: string
    ): Promise<Preference | HttpError> {
        const res = await this.httpClient.patch(`/users/${userId}/preferences`, { "notificationSettings": payload })
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Preference)
    }

    static async UpdateSignaturePreference(
        payload: SignatureSettings,
        userId: string
    ): Promise<Preference | HttpError> {
        const res = await this.httpClient.patch(`/users/${userId}/preferences`, { "signatureSettings": payload })
        if (isError(res)) {
            return res as HttpError
        }
        return (res as Preference)
    }
}

export default PreferenceService


// WEBPACK FOOTER //
// ./src/state/user/PreferenceService.ts